import React from 'react';

export const Cart = (props) => (
    <div>
        <h2>Cart Page</h2>
    </div>
);

